export default "__VITE_ASSET__DB7PoAA7__"